/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsmembergone2Inputs */

const en_groupsmembergone2 = /** @type {(inputs: Groupsmembergone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted account`)
};

const de_groupsmembergone2 = /** @type {(inputs: Groupsmembergone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelöschtes Konto`)
};

/**
* | output |
* | --- |
* | "Deleted account" |
*
* @param {Groupsmembergone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmembergone2 = /** @type {((inputs?: Groupsmembergone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmembergone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmembergone2(inputs)
	return de_groupsmembergone2(inputs)
});
export { groupsmembergone2 as "groupsMemberGone" }